import dynamic from 'next/dynamic';

import { lazyLoadImages } from 'src/utils/images';
import type { ProductCarouselRecommendationsSectionProps } from '../../../components/sections/ProductCarouselRecommendationsSection';
import type { SectionRenderer } from '../../../types/Section';
import type { Transformer } from '../../../types/Transformer';
import type { ProductCarouselRecommendationsContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<ProductCarouselRecommendationsSectionProps> =
  dynamic<ProductCarouselRecommendationsSectionProps>(() =>
    import('../../../components/sections/ProductCarouselRecommendationsSection').then(
      (mod) => mod.ProductCarouselRecommendationsSection,
    ),
  );

export const transformer: Transformer<
  ProductCarouselRecommendationsContentSection,
  ProductCarouselRecommendationsSectionProps
> = ({ placement_type, _metadata, tracking_title }, { pageMetadata, positionMetadata }) => ({
  uid: _metadata.uid,
  props: {
    currency: pageMetadata.currency,
    hasDisabledCookies: !pageMetadata.functionalCookiesConsented,
    placementType: placement_type,
    sessionId: pageMetadata.recommendationsSessionId,
    trackingTitle: tracking_title,
    lazyImages: lazyLoadImages(positionMetadata.position),
  },
});
